<template>
  <v-sheet :width="width">
    <v-select
      v-model="currentLanguage"
      :items="items"
      dense
      solo
      flat
      required
      append-icon=""
      class="custom-language"
      hide-details
      :menu-props="{bottom: true, offsetY: true}"
      @change="changeLocale"
    >
      <template #selection="{item}">
        <!--        <v-img alt="country" :src="require(`@/assets/images/flags/${item}.png`)" max-width="30" />-->
        {{ item.text }}
      </template>
      <template #item="{item}">
        <!--        <v-img alt="country" :src="require(`@/assets/images/flags/${item}.png`)" max-width="30" />-->
        {{ item.text }}
      </template>
    </v-select>
  </v-sheet>
</template>

<script>
import {getItem, setItem} from '@/helpers/persistantStorage'
import {mapMutations, mapState} from 'vuex'
import {LANG} from '@/helpers/variables/language'

export default {
  name: 'LanguageSelect',
  inheritAttrs: false,
  data: () => ({
    items: [
      {text: 'En', value: LANG.EN},
      {text: 'Ru', value: LANG.RU},
    ],
  }),
  props: {
    width: {
      type: [String, Number],
      default: 55,
    },
  },
  computed: {
    ...mapState({
      isCheckLocale: (state) => state.isCheckLocale,
    }),
    currentLanguage: {
      get() {
        return getItem('nt_system_language') || LANG.EN
      },
      set() {
        const {locale} = this.$i18n
        switch (locale) {
          case LANG.RU:
            return LANG.RU
          case LANG.EN:
            return LANG.EN
          default:
            return LANG.RU
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      changeCheckLocale: 'CHANGE_LOCALE',
    }),
    changeLocale(locale) {
      this.$i18n.locale = locale
      setItem('nt_system_language', locale)
      this.changeCheckLocale({check: false, locale})
      this.$nextTick(() => {
        this.changeCheckLocale({check: true, locale})
      })
    },
  },
}
</script>
